// Community invite links, shared across boards. Surfaced on /discord and
// /whatsapp and in the landing footer.

export const DISCORD_INVITE_URL = "https://discord.gg/xTpAbmPKVB";

export const WHATSAPP_INVITE_URL = "https://chat.whatsapp.com/EMBJcSbjPprCIq9HeWhiqy";
